import { render, staticRenderFns } from "./historical-transaction-details.vue?vue&type=template&id=b17a3456&scoped=true&"
import script from "./historical-transaction-details.vue?vue&type=script&lang=js&"
export * from "./historical-transaction-details.vue?vue&type=script&lang=js&"
import style0 from "./historical-transaction-details.vue?vue&type=style&index=0&id=b17a3456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17a3456",
  null
  
)

export default component.exports